import React, { useState } from 'react';
import { Button, TextField, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    
  } from '@mui/material';
import CustomButton from "../CommonComponents/CustomButton";
import CustomTextField from "../CommonComponents/CustomTextField";
import CustomCancelButton from '../CommonComponents/CustomCancelButton';
import axios from 'axios';
import { useSelector } from "react-redux";
import { Checkbox, Typography } from '@mui/material';
import CustomDialogBox from "../CommonComponents/CustomDialogBox";
import { maintenanceApi } from '../../Restclient/datacollection';
import { useApiHandler } from '../../hooks/useApiHandler';
import { ErrorTypes } from '../../Restclient/axiosConfig';

function epochToIndianTimestamp(epochSeconds) {
  // Convert seconds to milliseconds for Date object 
  let wenttime = new Date(epochSeconds * 1000); 
  let wenttimeyear = wenttime.getFullYear().toString(); 
  let wenttimemonth = (wenttime.getMonth() + 1).toString().padStart(2, "0"); 
  let wenttimedaydate = wenttime.getDate().toString().padStart(2, "0"); 
  let wenttimehour = wenttime.getHours().toString().padStart(2, "0"); 
  let wenttimeminute = wenttime.getMinutes().toString().padStart(2, "0"); 
  let wenttimesec = wenttime.getSeconds().toString().padStart(2, "0"); 
  let wenttimemsec = wenttime.getMilliseconds().toString().padStart(3, "0"); // Format: YYYY-MM-DD HH:MM:SS.mmm 
  return `${wenttimeyear}-${wenttimemonth}-${wenttimedaydate} ${wenttimehour}:${wenttimeminute}:${wenttimesec}.${wenttimemsec}`; 
}

const UserForm = React.memo(({ id, maintenanceinfo, template, lastmaintenanceperformeddate, maintenanceintervaldays, nextmaintenancedate }) => {
    
    const themechange = useSelector((state) => state.themedata.theme)
    const [devicesdata, setDevicesData] = useState([])
    const [responses, setResponses] = useState(
        template.map((question) => ({
        question: question.description,
        response: question.responseType === 'Multiple Choice' ? '' : null,
        options: question.options,
        responseType: question.responseType,
        CheckListItemID: question.CheckListItemID
        }))
    );
    const [errorQuestionLength, setErrorQuestionLength] = useState(false);
    const devicedetailsobject = useSelector((state) => state.mainpagedata.devicedetailsobject);
    const[deleteDashboardFailed, setDashboardFailed] = useState(false);
    const[deleteDashboardSuccess, setDashboardSuccess] = useState(false);
    const[errorMessage, setErrorMessage] = useState('');
    
    const { callApi } = useApiHandler({
        [ErrorTypes.NOT_FOUND]: 'Resource not found.',
        [ErrorTypes.FORBIDDEN]: 'You do not have permission to access this resource.',
        [ErrorTypes.SERVER_ERROR]: 'Server error occurred. Please try again.'
    });
    
    const handleResponseChange = (type, index, value) => {
        // if(type === 'Descriptive'){
        //     let num = value.length;
        //     if (isNaN(num) || num < 5 || num > 30) {
        //         setErrorQuestionLength(true)
        //     }

        // }

        const updatedResponses = responses.map((response, i) =>
        i === index ? { ...response, response: value } : response
        );
        setResponses(updatedResponses);
    };
    const handleErrorQuestionLength = () => setErrorQuestionLength(false);
    const [confirmSaveChangesDialog, setConfirmSaveChangesDialog] = useState(false);

    function isValidLength(value, minLength, maxLength) {
        return value.length >= minLength && value.length <= maxLength;
    }
    
    function handleCloseDeleteDashboardFailed(){
        setDashboardFailed(false) 
    }

    function handleCloseDeleteDashboardSuccess(){
        setDashboardSuccess(false) 
    }

    const saveUserFormcallback = (response) => {
        
        if(response && response.data?.success == true){
            setConfirmSaveChangesDialog(false)
            setDashboardSuccess(true)
        }else{
            const errorMsg = response.data?.message || response.message || "Failed to record User Response. Please try again!";
            setErrorMessage(errorMsg);
            setDashboardFailed(true)
        }
        
    }

    function handleSave(){
        
        // alert('Responses saved successfully!');
        // // Here, you would send the responses to the backend using axios or fetch
        // axios.post('http://localhost:4000/save-responses', responses)
        //   .then(() => alert('Responses saved to the server!'))
        //   .catch((error) => console.error('Error saving responses:', error));
        setConfirmSaveChangesDialog(true)
    };

    const handleconfirmSaveChangesDialogSave = async () => {
        var objecttosave = {
            id:id,
            DeviceID : maintenanceinfo,
            responses : responses
        }
        
        
        await callApi(
            () => maintenanceApi.saveUserForm(objecttosave),
            {
                showDialog: false,
                hideDialogOnStatusCodes: [404],
                useBackendMessage: true,
                onSuccess: (response) => {
                    
                    if(response.data.success == true){
                        setConfirmSaveChangesDialog(false);
                        setDashboardSuccess(true);
                    }else{
                        const errorMsg = response.data?.message || response.message || "Failed to record User Response. Please try again!";
                        setErrorMessage(errorMsg);
                        setDashboardFailed(true);
                    }
                },
                onError: (error) => {
                    
                    const errorMsg = error.response?.data?.message || 
                                    error.message || 
                                    "Network error. Failed to save user responses. Please check your connection and try again.";
                    setErrorMessage(errorMsg);
                    setDashboardFailed(true);
                }
            }
        );
        
        
    }

  function handleconfirmSaveChangesDialogClose(){
    setConfirmSaveChangesDialog(false)
  }

  return (
    <div style={{ border: '1px solid #ccc', padding: '20px'}}>
      
      <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"0px"}}>Device : {devicedetailsobject[maintenanceinfo]?.Name}</Typography>
      <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"0px"}}>Last Maintenance Performed Date : {epochToIndianTimestamp(lastmaintenanceperformeddate)}</Typography>
      <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"0px"}}>Maintenance Interval Days : {maintenanceintervaldays}</Typography>
      <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"0px"}}>Next Maintenance Date : {epochToIndianTimestamp(nextmaintenancedate)}</Typography>
     
        {template.map((question, index) => (
          <div key={index} style={{ margin: '20px 0' }}>
            
            <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"0px"}}>{question.description}</Typography>
            {question.responseType === 'Yes/No' && (
              <RadioGroup
                row
                value={responses[index].response || ''}
                onChange={(e) => handleResponseChange('Yes/No',index, e.target.value)}
              >
                <FormControlLabel 
                    sx={{
                      "&:before": {
                          borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`  
                      },
                      "&:hover:not(.Mui-disabled):before": {
                          borderBottom: '2px solid #008CD7',
                      },
                      "&:after": {
                          borderBottom: '2px solid #008CD7',
                      },
                      margin: 0,
                      padding: 0,
                      width: '100px',
                      fontSize: "18px",
                      fontFamily: "Roboto",
                      fontWeight: '700 !important',
                      color: 'var(--PrimaryText)',
                      '& .MuiInputBase-input': {
                          paddingLeft: 0
                      },
                      '& .MuiInputBase-input:focus': {
                          color: 'var(--HighlightedText_Stroke)',
                          borderBottom: '2px solid var(--HighlightedText_Stroke)',
                          backgroundColor: 'transparent',
                          fontWeight: '700 !important',
                          '& .MuiSvgIcon-root': {
                              color: 'var(--HighlightedText_Stroke) !important'
                          },
                      },
                      '& .MuiInputBase-input:focus .MuiSvgIcon-root': {
                          color: 'var(--HighlightedText_Stroke)',       //not working
                      },
                      '& .MuiSvgIcon-root': {
                          color: 'var(--PrimaryText)'
                      },
                      '& .MuiNativeSelect-select': {
                          paddingTop: 0,
                          paddingBottom: 0,
                      },
                      '& .MuiNativeSelect-select option': {
                          backgroundColor: 'var(--dropdown-bg) !important',
                          fontSize: "18px",
                          fontFamily: "Roboto",
                          fontWeight: 400,
                          color: 'var(--PrimaryText) !important',
                          borderBottom: '2px solid var(--HighlightedText_Stroke)',  //not working
                      },
                      '& .MuiNativeSelect-select option:checked': {
                          backgroundColor: 'var(--dropdown-bg) !important',
                          color: 'var(--White) !important',
                          fontWeight: '700 !important',
                          borderColor: '2px solid var(--HighlightedText_Stroke)'
                      },
                      '& .MuiInputBase-input option:hover': {
                          backgroundColor: '#005D8F !important',
                      },
      
                  }}
                  MenuProps={{
                      PaperProps:{
                          sx:{
                              width:"100px",
                              bgcolor:themechange==='dark'?'#3C3C3C':'#C1C1C1',
                              borderBottom:'2px solid #008CD7',
                              borderRadius:0,
                              boxShadow:'none',
                              maxHeight:'250px',
                              overflow:'auto',
                              color:themechange==='dark'?'#FFFFFF':'#3C3C3C',
                          }
                      },               
                  }}   value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel 
                    sx={{
                        "&:before": {
                            borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`  
                        },
                        "&:hover:not(.Mui-disabled):before": {
                            borderBottom: '2px solid #008CD7',
                        },
                        "&:after": {
                            borderBottom: '2px solid #008CD7',
                        },
                        margin: 0,
                        padding: 0,
                        width: '100px',
                        fontSize: "18px",
                        fontFamily: "Roboto",
                        fontWeight: '700 !important',
                        color: 'var(--PrimaryText)',
                        '& .MuiInputBase-input': {
                            paddingLeft: 0
                        },
                        '& .MuiInputBase-input:focus': {
                            color: 'var(--HighlightedText_Stroke)',
                            borderBottom: '2px solid var(--HighlightedText_Stroke)',
                            backgroundColor: 'transparent',
                            fontWeight: '700 !important',
                            '& .MuiSvgIcon-root': {
                                color: 'var(--HighlightedText_Stroke) !important'
                            },
                        },
                        '& .MuiInputBase-input:focus .MuiSvgIcon-root': {
                            color: 'var(--HighlightedText_Stroke)',       //not working
                        },
                        '& .MuiSvgIcon-root': {
                            color: 'var(--PrimaryText)'
                        },
                        '& .MuiNativeSelect-select': {
                            paddingTop: 0,
                            paddingBottom: 0,
                        },
                        '& .MuiNativeSelect-select option': {
                            backgroundColor: 'var(--dropdown-bg) !important',
                            fontSize: "18px",
                            fontFamily: "Roboto",
                            fontWeight: 400,
                            color: 'var(--PrimaryText) !important',
                            borderBottom: '2px solid var(--HighlightedText_Stroke)',  //not working
                        },
                        '& .MuiNativeSelect-select option:checked': {
                            backgroundColor: 'var(--dropdown-bg) !important',
                            color: 'var(--White) !important',
                            fontWeight: '700 !important',
                            borderColor: '2px solid var(--HighlightedText_Stroke)'
                        },
                        '& .MuiInputBase-input option:hover': {
                            backgroundColor: '#005D8F !important',
                        },
  
                        }}
                        MenuProps={{
                            PaperProps:{
                                sx:{
                                    width:"100px",
                                    bgcolor:themechange==='dark'?'#3C3C3C':'#C1C1C1',
                                    borderBottom:'2px solid #008CD7',
                                    borderRadius:0,
                                    boxShadow:'none',
                                    maxHeight:'250px',
                                    overflow:'auto',
                                    color:themechange==='dark'?'#FFFFFF':'#3C3C3C',
                                }
                            },               
                        }}  value="No" control={<Radio />} label="No" />
              </RadioGroup>
            )}
            {question.responseType === 'Multiple Choice' && (
              <RadioGroup
                row
                value={responses[index].response || ''}
                onChange={(e) => handleResponseChange('Multiple Choice', index, e.target.value)}
              >
                {question.options.map((option, oIndex) => (
                  <FormControlLabel 
                      sx={{
                    "&:before": {
                        borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`  
                    },
                    "&:hover:not(.Mui-disabled):before": {
                        borderBottom: '2px solid #008CD7',
                    },
                    "&:after": {
                        borderBottom: '2px solid #008CD7',
                    },
                    margin: 0,
                    padding: 0,
                    width: '100px',
                    fontSize: "18px",
                    fontFamily: "Roboto",
                    fontWeight: '700 !important',
                    color: 'var(--PrimaryText)',
                    '& .MuiInputBase-input': {
                        paddingLeft: 0
                    },
                    '& .MuiInputBase-input:focus': {
                        color: 'var(--HighlightedText_Stroke)',
                        borderBottom: '2px solid var(--HighlightedText_Stroke)',
                        backgroundColor: 'transparent',
                        fontWeight: '700 !important',
                        '& .MuiSvgIcon-root': {
                            color: 'var(--HighlightedText_Stroke) !important'
                        },
                    },
                    '& .MuiInputBase-input:focus .MuiSvgIcon-root': {
                        color: 'var(--HighlightedText_Stroke)',       //not working
                    },
                    '& .MuiSvgIcon-root': {
                        color: 'var(--PrimaryText)'
                    },
                    '& .MuiNativeSelect-select': {
                        paddingTop: 0,
                        paddingBottom: 0,
                    },
                    '& .MuiNativeSelect-select option': {
                        backgroundColor: 'var(--dropdown-bg) !important',
                        fontSize: "18px",
                        fontFamily: "Roboto",
                        fontWeight: 400,
                        color: 'var(--PrimaryText) !important',
                        borderBottom: '2px solid var(--HighlightedText_Stroke)',  //not working
                    },
                    '& .MuiNativeSelect-select option:checked': {
                        backgroundColor: 'var(--dropdown-bg) !important',
                        color: 'var(--White) !important',
                        fontWeight: '700 !important',
                        borderColor: '2px solid var(--HighlightedText_Stroke)'
                    },
                    '& .MuiInputBase-input option:hover': {
                        backgroundColor: '#005D8F !important',
                    },

                    }}
                    MenuProps={{
                        PaperProps:{
                            sx:{
                                width:"100px",
                                bgcolor:themechange==='dark'?'#3C3C3C':'#C1C1C1',
                                borderBottom:'2px solid #008CD7',
                                borderRadius:0,
                                boxShadow:'none',
                                maxHeight:'250px',
                                overflow:'auto',
                                color:themechange==='dark'?'#FFFFFF':'#3C3C3C',
                            }
                        },               
                      }}key={oIndex} value={option} control={<Radio />} label={option} />
                ))}
              </RadioGroup>
            )}
            {question.responseType === 'Descriptive' && (
              <TextField
                fullWidth
                variant="standard"
                value={responses[index].response || ''}
                inputProps={{ minLength: 5, maxLength: 40 }}
                //     helperText={
                //         responses[index].response != null && responses[index].response != undefined &&
                //         (!isValidLength(responses[index].response, 5, 40))
                //         ? `Length must be between 5 and 40 with no special characters and whitespaces allowed. ${responses[index].response != undefined && responses[index].response != null ? responses[index].response.length : 0 }/40 characters used`
                //         : `${responses[index].response.length}/40 characters used`
                //     }
                //     FormHelperTextProps={{
                //         sx: {
                //         color: !isValidLength(responses[index].response, 5, 30)
                //             ? '#DC272D'
                //             : '#00943D'
                //         }
                //     }}
                sx={{marginLeft:"16px",marginTop:"0px",fontSize:"16px",fontFamily:"Roboto",marginLeft:"14px",
                  '& .MuiInputBase-input:focus': {
                      color: '#008CD7',
                  },
                  '& .MuiInputBase-root': {
                      fontFamily: 'Roboto',
                      fontSize: '16px',
                      fontWeight: '700',
                      color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                  },
                  '& .MuiInput-root .MuiInputBase-input': {
                      
                  },
                  '& .MuiInputBase-root::before': {
                      borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                  },
                  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                      borderBottom: '2px solid #008CD7',
                  },
                  '& .MuiInputBase-root::after': {
                      borderBottom: '2px solid #008CD7',
  
                  },
}}
                onChange={(e) => handleResponseChange('Descriptive',index, e.target.value)}
                label=""
              />
            )}
          </div>
        ))}
          <Dialog 
              open={confirmSaveChangesDialog} 
              onClose={handleconfirmSaveChangesDialogClose}
              BackdropProps={{
                  sx:{
                      backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                  }
              }}
              sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}>
              <DialogTitle sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>{"Confirm Save Changes"}</DialogTitle>
              <DialogContent>
                  <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                      <div>
                          <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"25px",marginBottom:"10px"}}>Are you sure to save changes? </Typography>
                      </div>
                  </DialogContentText>
              </DialogContent>
              <DialogActions sx={{justifyContent:'center'}}>
                  <Button onClick={handleconfirmSaveChangesDialogSave} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'125px',fontSize: '16px',textTransform:'capitalize', marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" autoFocus>
                      Confirm
                  </Button>
                  <CustomCancelButton onClick={handleconfirmSaveChangesDialogClose} buttonText={'Cancel'}></CustomCancelButton>
              </DialogActions>
          </Dialog> 
           <CustomDialogBox
                dialogTitle={"Length of Description"}
                dialogText={"Length of Description should be  greater than 5 and less than 30"}
                openDialog={errorQuestionLength}
                handleCloseDialog={handleErrorQuestionLength}
                handleConfirmDialog={handleErrorQuestionLength}
                confirmText={"Ok"}
                cancelText={"Cancel"}
            />
            <CustomDialogBox dialogTitle={"User Responses Save"} dialogText={errorMessage || "Failed to record User Response. Try Again!"}  openDialog={deleteDashboardFailed}  handleCloseDialog={handleCloseDeleteDashboardFailed}  handleConfirmDialog={handleCloseDeleteDashboardFailed}  confirmText={"Ok"}  cancelText={"Cancel"} type={"Error"}/>
            <CustomDialogBox dialogTitle={"User Responses Save"} dialogText={"User Responses recorded Successfully."}  openDialog={deleteDashboardSuccess}  handleCloseDialog={handleCloseDeleteDashboardSuccess}  handleConfirmDialog={handleCloseDeleteDashboardSuccess}  confirmText={"Ok"}  cancelText={"Cancel"} type={"Success"}/>
      <Button sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'250px',fontSize: '16px',textTransform:'capitalize', marginTop:"10px",marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" onClick={handleSave}>
          Save Responses
      </Button>
    </div>
  );
});

export default UserForm;
